export default __webpack_public_path__ + "static/media/8.887696a0.png";